import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companySiteApiClient } from '@src/api/company/site/companySiteApiClient';
import SpinnerOverlay from '@src/components/SpinnerOverlay';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RedirectToCompanyTopPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function redirectToTopPage() {
      const res = await companySiteApiClient.topPageUrl();
      handleApiResponse(res, (data) => {
        setLoading(false);
        navigate(data.url);
      });
    }
    redirectToTopPage();
  }, [navigate]);

  return (
    <>
      <SpinnerOverlay loading={loading} />
    </>
  );
}

export default RedirectToCompanyTopPage;
